import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from "react-compare-slider";
import { BEFORE_AFTER } from "../data/content";
import { useReveal } from "../hooks/useReveal";

export default function BeforeAfter() {
  const ref = useReveal();
  return (
    <section
      id="before-after"
      data-testid="beforeafter-section"
      className="relative py-24 lg:py-40 bg-[#1C1917] text-white overflow-hidden"
    >
      <div ref={ref} className="reveal max-w-[90rem] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-4">
          <p className="overline text-stone-400 mb-6 flex items-center gap-3">
            Transformation
          </p>
          <h2
            data-testid="beforeafter-headline"
            className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-white"
          >
            The room stayed.
            <br />
            <em className="italic text-white/60">Everything else changed.</em>
          </h2>
          <p className="mt-8 text-stone-300 leading-relaxed max-w-md">
            Drag the divider to reveal how a bare architectural volume becomes a
            VARNELLA composition — through wallpaper, ceiling, film and
            lamination working as one.
          </p>
          <div className="mt-10 flex items-center gap-8">
            <div>
              <p className="font-serif-display text-4xl">72<span className="text-[#8BA6BE]">h</span></p>
              <p className="mt-2 text-[11px] tracking-[0.25em] uppercase text-stone-400">Install time</p>
            </div>
            <div>
              <p className="font-serif-display text-4xl">1<span className="text-[#8BA6BE]">/1</span></p>
              <p className="mt-2 text-[11px] tracking-[0.25em] uppercase text-stone-400">Custom edition</p>
            </div>
          </div>
        </div>
        <div className="lg:col-span-8">
          <div
            data-testid="beforeafter-slider"
            className="rounded-sm overflow-hidden aspect-[16/10] shadow-[0_30px_60px_rgba(0,0,0,0.5)]"
          >
            <ReactCompareSlider
              itemOne={
                <ReactCompareSliderImage
                  src={BEFORE_AFTER.before}
                  alt="Before — bare architectural volume"
                  style={{ filter: "grayscale(0.15)" }}
                />
              }
              itemTwo={
                <ReactCompareSliderImage
                  src={BEFORE_AFTER.after}
                  alt="After — VARNELLA bespoke surface composition"
                />
              }
              position={45}
            />
          </div>
          <div className="mt-4 flex items-center justify-between text-[11px] tracking-[0.25em] uppercase text-stone-400">
            <span>← Before</span>
            <span>After →</span>
          </div>
        </div>
      </div>
    </section>
  );
}
